import { Flex, Icon } from '@chakra-ui/react';
import {
  ChevronDown,
  ChevronUp,
} from '../../team-productivity/components/chevron';

export const TableSort = ({ direction, onClick, ...props }) => {
  return (
    <Flex
      flexDir="column"
      alignItems="center"
      justifyContent="center"
      cursor="pointer"
      rowGap="2px"
      onClick={() => {
        switch (direction) {
          case 'desc':
            onClick?.('default');
            break;

          case 'asc':
            onClick?.('desc');
            break;

          default:
            onClick?.('asc');
            break;
        }
      }}
      {...props}
    >
      {direction !== 'desc' ? <Icon as={ChevronUp} /> : null}
      {direction !== 'asc' ? <Icon as={ChevronDown} /> : null}
    </Flex>
  );
};
